"use client"

import * as React from "react"

import { cn } from "@/lib/utils"
import { useThemeConfig } from "@/hooks/use-theme-config"

export type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  ref?: React.Ref<HTMLInputElement>
}

// Terminal mode styles for Bloomberg terminal look
const terminalInputStyles = "!bg-black !border-emerald-500 !text-emerald-400 placeholder:!text-emerald-500/50 focus-visible:!ring-emerald-500/50 focus-visible:!border-emerald-400"

function Input({ className, type, ref, ...props }: InputProps) {
  const { isTerminal, mounted } = useThemeConfig()
  const showTerminalStyles = mounted && isTerminal

  return (
    <input
      type={type}
      className={cn(
        "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background sm:text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        showTerminalStyles && terminalInputStyles,
        className
      )}
      ref={ref}
      {...props}
    />
  )
}
Input.displayName = "Input"

export { Input }
